<template>
  <c-box position="relative">
    <c-box
      tabindex="1"
      display="inline-block"
      cursor="pointer"
      @click.stop="toggle"
      @keydown.enter="toggle"
    >
      <c-text as="span" v-chakra display="inline-block">
        <c-icon name="globe" size="2rem" color="brand.black"
      /></c-text>
    </c-box>
    <c-box
      v-show="isOpen"
      v-click-outside="hide"
      background="brand.grayLight"
      position="absolute"
      zIndex="10"
      right="0px"
      padding="5px 10px"
      borderRadius="input"
      textAlign="left"
    >
      <ul v-chakra listStyleType="none" margin="0" padding="5px 15px">
        <li
          v-for="lang in langs"
          :key="`lang-${lang.languageCode}`"
          @click="selectLanguage(lang.languageCode)"
          @keydown.enter="selectLanguage(lang.languageCode)"
          tabindex="2"
          v-chakra="{
            listStyle: 'none',
            fontSize: 'md',
            fontWeight: '700',
            lineHeight: 'base',
            marginBottom: '-3px',
            color: 'brand.black',
            whiteSpace: 'nowrap',
            cursor: 'pointer',
            _hover: {
              color: 'brand.purple',
            },
          }"
        >
          <img
            :src="`/img/languages/${lang.languageCode}.png`"
            :alt="`Flag ${lang.languageDisplay}`"
            v-chakra="{
              marginRight: '7px',
              _hover: {
                opacity: '0.5',
              },
            }"
          />
          <c-text as="span">{{ lang.languageDisplay }}</c-text>
        </li>
      </ul>
    </c-box>
  </c-box>
</template>

<script>
import Icon from "@/design-system/elements/Icon";
import { CBox, CIcon, CText } from "@chakra-ui/vue";

const allLangs = [
  {
    languageCode: "en",
    languageDisplay: "English",
  },
  {
    languageCode: "fi",
    languageDisplay: "Suomi",
  },
  {
    languageCode: "de",
    languageDisplay: "Deutsch",
  },
  {
    languageCode: "sv",
    languageDisplay: "Svenska",
  },
  {
    languageCode: "nl",
    languageDisplay: "Nederlands",
  },
  {
    languageCode: "da",
    languageDisplay: "Dansk",
  },
  {
    languageCode: "fr",
    languageDisplay: "Français",
  },
  {
    languageCode: "es",
    languageDisplay: "Español",
  },
  {
    languageCode: "nb",
    languageDisplay: "Norsk",
  },
];

const filterLangList = (locale) => allLangs.filter((lang) => lang.languageCode !== locale);

export default {
  name: "LocaleChanger",
  components: {
    Icon,
    CIcon,
    CBox,
    CText,
  },
  directives: {
    "click-outside": {
      bind(el, binding, vnode) {
        el.clickOutsideEvent = (event) => {
          if (!(el === event.target || el.contains(event.target))) {
            vnode.context[binding.expression](event);
          }
        };
        document.body.addEventListener("click", el.clickOutsideEvent);
      },
      unbind(el) {
        document.body.removeEventListener("click", el.clickOutsideEvent);
      },
    },
  },
  data() {
    return {
      isOpen: false,
      langs: filterLangList(this.$i18n.locale),
    };
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
    },
    hide() {
      this.isOpen = false;
    },
    selectLanguage(lang) {
      this.$i18n.locale = lang;
      this.isOpen = false;
      this.langs = filterLangList(lang);
      localStorage.setItem("unauthenticated-language", lang);
    },
  },
};
</script>
